import { FaqEntriesResp } from 'types/api/response/faq-entries-resp'
import { api } from '@marketplace-web/core-api/core-api-client-data'

export const getFaqEntries = () => api.get<FaqEntriesResp>('/faq_entries')
